// If user typed a SKU and clicks a predictive product, open its matching variant
(() => {
  const looksLikeSku = s => /^[\w\-._/ ]{2,64}$/i.test((s||'').trim());

  document.addEventListener('click', (e) => {
    const link = e.target.closest('.predictive-search__product-item a.line-item__content-wrapper');
    if (!link) return;

    const input = document.querySelector('#predictive-search-form [name="q"]') ||
                  document.querySelector('.predictive-search__input');
    const sku = (input?.value || '').trim();
    if (!looksLikeSku(sku)) return;

    e.preventDefault();
    const url = new URL(link.href, location.origin);

    fetch(`${url.pathname}.js`)
      .then(r => r.json())
      .then(p => {
        const v = (p.variants || []).find(v => (v.sku || '').trim().toLowerCase() === sku.toLowerCase());
        if (v) location.assign(`${url.pathname}?variant=${v.id}`);
        else location.assign(link.href);
      })
      .catch(() => location.assign(link.href));
  }, true);
})();
